import { customFetch, appendFormDataWithObjectValues } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { getM8AdminURL } from 'services/production/utils/getM8URL';

type Params = {
  type: string;
  defaultCountValue: number;
  name: string;
};

export const updateCalculationComponent = async (
  params: Params
): Promise<void> => {
  const body = new FormData();

  appendFormDataWithObjectValues(body, params);

  const response = await customFetch(
    getM8AdminURL('updateCalculationComponent'),
    { method: 'PUT', body }
  );

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }
};
